import * as React from 'react';

export default function Spaces() {
  return <div>Sup</div>;
}
